// hard coded for now
export const desiredAmountAsNumber = 10_000;
export const lowLimitAsNumber = 5_000;
export const dailyLimitAsNumber = 10_000;
export const desiredAmount = desiredAmountAsNumber.toString();
export const lowLimit = lowLimitAsNumber.toString();
export const dailyLimit = dailyLimitAsNumber.toString();
//# sourceMappingURL=autofill-constants.js.map